var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{attrs:{"id":"prism_top"}}),_c('div',{attrs:{"id":"prism_footer"}}),_c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-4 logo"},[_c('img',{attrs:{"src":require('@/assets/img/logo.png'),"alt":"Nave do Conhecimento"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }